<div class="container a-center page-404 text-center">
    <h3>Whoops!</h3>
    <h1 class="number_404">404</h1>
    <h2>Nothing Was Found!</h2>
    <p>Either Something Get Wrong or the Page Doesn't Exist Anymore.</p>
    <div class="gt3_module_button_list"><a href="{{WPSiteUrl}}">Take me home</a></div>
</div>
